export default {"src":"/_next/static/media/delivery.945b8ba9.svg","height":501,"width":614};